import file_add from './file-add.svg';
import file_archive from './file-archive.svg';
import file_blank from './file-blank.svg';
import file_check from './file-check.svg';
import file_close from './file-close.svg';
import file_cloud from './file-cloud.svg';
import file_cloud_add from './file-cloud-add.svg';
import file_cloud_check from './file-cloud-check.svg';
import file_cloud_close from './file-cloud-close.svg';
import file_cloud_download from './file-cloud-download.svg';
import file_cloud_off from './file-cloud-off.svg';
import file_cloud_remove from './file-cloud-remove.svg';
import file_cloud_upload from './file-cloud-upload.svg';
import file_code from './file-code.svg';
import file_document from './file-document.svg';
import file_download from './file-download.svg';
import file_download_package from './file-download-package.svg';
import file_edit from './file-edit.svg';
import file_files from './file-files.svg';
import file_folder from './file-folder.svg';
import file_folder_add from './file-folder-add.svg';
import file_folder_check from './file-folder-check.svg';
import file_folder_close from './file-folder-close.svg';
import file_folder_code from './file-folder-code.svg';
import file_folder_document from './file-folder-document.svg';
import file_folder_download from './file-folder-download.svg';
import file_folder_edit from './file-folder-edit.svg';
import file_folder_open from './file-folder-open.svg';
import file_folder_remove from './file-folder-remove.svg';
import file_folder_search from './file-folder-search.svg';
import file_folder_upload from './file-folder-upload.svg';
import file_folders from './file-folders.svg';
import file_note from './file-note.svg';
import file_note_edit from './file-note-edit.svg';
import file_note_search from './file-note-search.svg';
import file_notebook from './file-notebook.svg';
import file_remove from './file-remove.svg';
import file_search from './file-search.svg';
import file_upload from './file-upload.svg';

export const V2_FILE_ICONS: { [char: string]: string } = {
  file_add,
  file_archive,
  file_blank,
  file_check,
  file_close,
  file_cloud,
  file_cloud_add,
  file_cloud_check,
  file_cloud_close,
  file_cloud_download,
  file_cloud_off,
  file_cloud_remove,
  file_cloud_upload,
  file_code,
  file_document,
  file_download,
  file_download_package,
  file_edit,
  file_files,
  file_folder,
  file_folder_add,
  file_folder_check,
  file_folder_close,
  file_folder_code,
  file_folder_document,
  file_folder_download,
  file_folder_edit,
  file_folder_open,
  file_folder_remove,
  file_folder_search,
  file_folder_upload,
  file_folders,
  file_note,
  file_note_edit,
  file_note_search,
  file_notebook,
  file_remove,
  file_search,
  file_upload,
};

export const V2_FILE_ICON_NAMES: string[] = Object.keys(V2_FILE_ICONS);
